"use client";

import { useEffect, useRef } from "react";
import Icon from "@/components/ui/AppIcon";

export default function HowItWorksHero() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".scroll-fade-up").forEach((el, i) => {
              setTimeout(() => el.classList.add("is-visible"), i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="pt-32 pb-20 bg-hero-gradient relative overflow-hidden"
    >
      <div className="max-w-5xl mx-auto px-5 sm:px-8 text-center">
        <div className="scroll-fade-up">
          <span className="teal-badge mb-5">How It Works</span>
        </div>
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-[#1A2B2B] tracking-tight leading-tight mb-6 scroll-fade-up">
          Simple for pet owners.
          <br />
          <span className="gradient-text">Powerful for businesses.</span>
        </h1>
        <p className="text-lg sm:text-xl text-[#4A6363] max-w-3xl mx-auto leading-relaxed mb-10 scroll-fade-up">
          DogFob connects pet owners with trusted professionals through a privacy-first platform. Here's exactly how it works for everyone involved.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4 scroll-fade-up">
          <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-[#E2EDED]">
            <Icon name="ShieldCheckIcon" size={18} className="text-teal-500" />
            <span className="text-sm font-semibold text-[#1A2B2B]">Privacy-First</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-[#E2EDED]">
            <Icon name="LockClosedIcon" size={18} className="text-teal-500" />
            <span className="text-sm font-semibold text-[#1A2B2B]">Consent-Based</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-[#E2EDED]">
            <Icon name="CheckCircleIcon" size={18} className="text-teal-500" />
            <span className="text-sm font-semibold text-[#1A2B2B]">Secure & Encrypted</span>
          </div>
        </div>
      </div>
    </section>
  );
}